import { z } from 'zod';

import { MatchingRecord } from '@eluve/utils';

import { AppointmentOutputArtifactTypesEnum } from './types';

export const AppointmentOutputArtifactTypesLookup = {
  PREVISIT_INSIGHTS: 'PREVISIT_INSIGHTS',
} as const satisfies MatchingRecord<AppointmentOutputArtifactTypesEnum>;

export const appointmentOutputArtifactTypeSchema = z.nativeEnum(
  AppointmentOutputArtifactTypesLookup,
);

export type AppointmentOutputArtifactType = z.infer<
  typeof appointmentOutputArtifactTypeSchema
>;

export const AppointmentOutputArtifactSchemas = {
  PREVISIT_INSIGHTS: z.object({
    content: z.string().optional(),
  }),
} as const satisfies Record<AppointmentOutputArtifactTypesEnum, z.ZodTypeAny>;
